
/**
 * 空间距离测量
 */

import DrawPolyline from "../plot/DrawPolyline"
import ConstantDraw from "../constants/ConstantDraw"
import { getSpace, getDistanceText } from "./utils/index"
import EditDistanceSpace from "./EditDistanceSpace"
class DistanceSpace extends DrawPolyline {

    constructor(options) {
        super(options);
        this.options = options;
        this.sum = 0;
        this.entitiesLabel = [];
        this.style={
            clampToGround:false
        }
    }

    leftClick(evt) {
        super.leftClick(evt); //调用
        var $this = this;
        var l = $this.positions.length;
        if (l == 2) {
            var lable = ConstantDraw.Style_Label;
            lable.pixelOffset=new Cesium.Cartesian2(0.0, -20.0);
            lable.text = "起点";
            var p = this.createPoint($this.positions[0], ConstantDraw.Style_KeyPos);
            this.entitiesLabel.push(p);
            this.entities.push(p);
            p.label = lable;
        }
        if (l > 2) {
            var start = $this.positions[l - 3];
            var end = $this.positions[l - 2];
            var dis = getSpace(start, end);
            var disTxt = getDistanceText(dis);
            this.sum += dis;
            var sumTxt = getDistanceText(this.sum);
            var lable = ConstantDraw.Style_Label;
            lable.pixelOffset=new Cesium.Cartesian2(0.0, -30.0);
            lable.text = `+${disTxt}\n总长:${sumTxt}`
            var p = this.createPoint(end, ConstantDraw.Style_KeyPos);
            this.entitiesLabel.push(p);
            this.entities.push(p);
            p.label = lable;
        }
    }

    rightClick(evt){
        var $this = this;
        var l = $this.positions.length;
        var start = $this.positions[l - 2];
        var end = $this.positions[l - 1];
        var dis = getSpace(start, end);
        var disTxt = getDistanceText(dis);
        this.sum += dis;
        var sumTxt = getDistanceText(this.sum);
        var lable = ConstantDraw.Style_Label;
        lable.pixelOffset=new Cesium.Cartesian2(0.0, -30.0);
        lable.text = `+${disTxt}\n总长:${sumTxt}`
        var p = this.createPoint(end, ConstantDraw.Style_KeyPos);
        this.entitiesLabel.push(p);
        this.entities.push(p);
        p.label = lable;

        super.rightClick(evt); //调用
    }

    initEditor() {
        var $this = this;
        $this.editHelp = new EditDistanceSpace(this.options); //初始化编辑类

    }

    reset() {
        super.reset();
        this.sum = 0;
        this.entitiesLabel = [];
    }

    initKeyPositions() {
        var arr = [];
        for (let i = 0; i < this.entitiesLabel.length; i++) {
            var pos = this.entitiesLabel[i].position.getValue();
            arr.push(pos);
        }
        this.positions = arr; //
        this.plot.attrPlot = {
            edit_positions: this.positions.slice(),
            entitiesLabel: this.entitiesLabel
        }; //标绘标识
    }

}

export default DistanceSpace